<scope-deliverable-sections-header
  *ngIf="deliverable.sections?.length && !config?.isTimeline"
  [config]="config"
  [level]="level" />

<scope-deliverable-sections-row
  *ngFor="let section of deliverable.sections; trackBy: trackById"
  [section]="section"
  [components]="componentsMap[section.id]"
  [config]="config"
  [deliverable]="deliverable"
  [feeMenuOptions]="feeMenuOptions"
  [componentMenuOptions]="componentMenuOptions"
  [level]="level"
  (onUpdateComponent)="onUpdateComponent.emit($event)"
  (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
  (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
  (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
  (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
  (onUpdateRole)="onUpdateRole.emit($event)"
  (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
  (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
  (onMoveComponent)="onMoveComponent.emit($event)"
  (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
  (onUpdateFeeItem)="onUpdateFeeItem.emit($event)">
</scope-deliverable-sections-row>
